import { useToast } from '../../../../providers/ToastProvider';
import { copyToClipboard } from '../../../../utils/clipboard';

interface CopyAddressActionProps {
    values: Record<string, string>;
}

function formatAddress(values: Record<string, string>): string {
    const stateZip = [values.state?.trim(), values.zip?.trim()].filter(Boolean).join(' ');
    return [values.address?.trim(), values.addressDetails?.trim(), values.city?.trim(), stateZip]
        .filter((part) => part && part.length > 0)
        .join(', ');
}

// The Practice card's header action (see D2Group's `action` slot in the
// design source) - copies the joined street/suite/city/state/zip using the
// live form values, same source every other field on this card reads from
// (so a not-yet-saved edit is reflected here too, not just the saved
// record).
export function CopyAddressAction({ values }: CopyAddressActionProps) {
    const { showToast } = useToast();

    const handleCopy = async () => {
        const address = formatAddress(values);
        if (!address) {
            showToast('Nothing to copy yet', 'error');
            return;
        }
        const copied = await copyToClipboard(address);
        showToast(
            copied ? 'Address copied' : 'Could not copy address',
            copied ? 'success' : 'error'
        );
    };

    return (
        <button
            type="button"
            onClick={() => void handleCopy()}
            className="text-[12px] font-semibold text-gray-500 hover:text-gray-900"
        >
            Copy address
        </button>
    );
}
